import { all } from 'redux-saga/effects';

import downloads from './downloads/sagas';
import search from './search/sagas';
import help from './help/sagas';

export default function* rootSaga() {
	return yield all([downloads, search, help]);
}
